
/* injects from baggage-loader */

( function() {
  function addCombo( editor, comboName, styleType, lang, entries, defaultLabel, styleDefinition, order ) {
    var config = editor.config,style = new CKEDITOR.style( styleDefinition );
    var names = entries.split( ';' ),values = [];
    var styles = {};
    for ( var i = 0; i < names.length; i++ ) {
      var parts = names[ i ];
      if ( parts ) {
        parts = parts.split( '/' );
        var vars = {},name = names[ i ] = parts[ 0 ];
        vars[ styleType ] = values[ i ] = parts[ 1 ] || name;
        styles[ name ] = new CKEDITOR.style( styleDefinition, vars );
        styles[ name ]._.definition.name = name;
      } else
        names.splice( i--, 1 );
    }
    editor.ui.addRichCombo( comboName, {
      label: editor.lang.lineheight.title,
      title: editor.lang.lineheight.title,
      toolbar: 'styles,' + order,
      allowedContent: style,
      requiredContent: style,
      panel: {
        css: [ CKEDITOR.skin.getPath( 'editor' ) ].concat( config.contentsCss ),
        multiSelect: false,
        attributes: { 'aria-label': editor.lang.lineheight.title }
      },
      init: function() {
        this.startGroup(editor.lang.lineheight.title);
        for ( var i = 0; i < names.length; i++ ) {
          var name = names[ i ];
          this.add( name, styles[ name ].buildPreview(), name );
        }
      },
      onClick: function( value ) {
        editor.focus();
        editor.fire( 'saveSnapshot' );
        var style = styles[ value ];
        editor[ this.getValue() == value ? 'removeStyle' : 'applyStyle' ]( style );
        editor.fire( 'saveSnapshot' );
      },
      onRender: function() {
        editor.on( 'selectionChange', function( ev ) {
          var currentValue = this.getValue();
          var elementPath = ev.data.path,elements = elementPath.elements;
          for ( var i = 0, element; i < elements.length; i++ ) {
            element = elements[ i ];
            for ( var value in styles ) {
              if ( styles[ value ].checkElementMatch( element, true, editor ) ) {
                if ( value != currentValue )
                  this.setValue( value );
                return;
              }
            }
          }
          this.setValue( '', defaultLabel );
        }, this );
      },
      refresh: function() {
        if ( !editor.activeFilter.check( style ) )
          this.setState( CKEDITOR.TRISTATE_DISABLED );
      }
    } );
  }
  CKEDITOR.plugins.add( 'lineheight', {
    requires: 'richcombo',
    lang: 'en,fr,es',
    init: function( editor ) {
      var config = editor.config;
      addCombo( editor, 'lineheight', 'size', editor.lang.lineheight.title, config.line_height, editor.lang.lineheight.title, config.lineHeight_style, 40 );
    }
  } );
} )();
CKEDITOR.config.line_height = '0.5;0.6;0.7;0.8;0.9;1;1.1;1.2;1.3;1.4;1.5;1.6;1.7;1.8;1.9;2;2.1;2.2;2.3;2.4;2.5;2.6;2.7;2.8;2.9;3;4;5;6;7;8;9;10';
CKEDITOR.config.lineHeight_style = {
  element: 'span',
  styles: {
    "display": "inline-block",
    "line-height": "#(size)"
  },
  overrides: [ {
    element: 'line-height', attributes: { 'size': null }
  } ]
};



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/plugins/lineheight/plugin.js